import React from "react";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import { translate } from "../../i18n";
import { acrAPI } from "utils/api";
import { Subscription } from "rxjs";

export class ServerInfo extends React.Component {
  private subscribtions: Subscription = new Subscription();
  public state = { 
    cpuConsumptionMessage: "", ramConsumptionMessage: "", diskFreeSpaceMessage: ""
  };


  private getServerInfo(serverStatusData:any): void {
      let resCpu = serverStatusData.cpuConsumption || "...";
      let resRam = serverStatusData.ramConsumption || "...";
      let resDisk = serverStatusData.diskFreeSpace || "...";
      this.setState({cpuConsumptionMessage:resCpu,ramConsumptionMessage:resRam,diskFreeSpaceMessage:resDisk});
  }

  constructor(props: any) {
    super(props);
    this.getServerInfo = this.getServerInfo.bind(this);
  }

  public componentDidMount(): void {
    this.setState({cpuConsumptionMessage: "...", ramConsumptionMessage: "...", diskFreeSpaceMessage: ".."})
    this.subscribtions.add(acrAPI.serverStatusSubject.subscribe(this.getServerInfo));
    acrAPI.getServerStatus();
  }

  public componentWillUnmount(): void {
    this.subscribtions.unsubscribe();
  }


  public render(): JSX.Element {
    return (
      <>        
        <Box display="flex" flexDirection="column" style={{ marginBottom: "1em" }}>
          <Typography variant="h5" data-cy="maintenance-server-info-title">{translate("Server info title")}</Typography>
          <Typography variant="h6">
          <Box display="flex" sx={{margin:'1em'}} flexDirection="column">
            <Typography>{translate("cpu usage title")} : {this.state.cpuConsumptionMessage} %</Typography>
            <Typography>{translate("memory usage title")} : {this.state.ramConsumptionMessage} MB</Typography>
            <Typography>{translate("disk free space title")}: {this.state.diskFreeSpaceMessage} GB</Typography>
            </Box>
          </Typography>               
        </Box>
      </>
    );
  }
}
